import type { CSSProperties, ReactNode } from 'react';

import { PiqueLogo } from '../../components/auth-components/pique-logo';
import * as styles from './index.css';

export type EmptyContentProps = {
  title?: ReactNode;
  description?: ReactNode;
  descriptionStyle?: CSSProperties;
};

export const Empty = ({
  title,
  description,
  descriptionStyle,
}: EmptyContentProps) => {
  return (
    <div className={styles.emptyContainer}>
      <PiqueLogo className={styles.emptySvg} />
      {title && (
        <p
          style={{
            marginTop: '30px',
            color: 'var(--affine-text-primary-color)',
            fontWeight: 700,
          }}
        >
          {title}
        </p>
      )}
      {description && (
        <p style={{ marginTop: title ? '8px' : '30px', ...descriptionStyle }}>
          {description}
        </p>
      )}
    </div>
  );
};

export default Empty;
